<div style="width: 100%" [hidden]="!dataSource">
  <div fxLayout="row">
      <mat-form-field class="user-search" fxFlex="50%">
        <mat-label>Search</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="userSearchTerm"
          (blur)="debounceFetchUsers()"
          (input)="debounceFetchUsers()"
        />
        <button
          *ngIf="userSearchTerm"
          matSuffix
          mat-icon-button
          (click)="userSearchTerm = ''; searchData();"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-paginator fxFlex="50%"
        #paginator
        [length]="totalUnapprovedUsers"
        [pageSize]="limitPerPage"
        [hidePageSize]="true"
        (page)="onPageEvent($event)"
      >
      </mat-paginator>
  </div>
  <table mat-table 
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortData($event)"
    fxLayoutGap="16px"
    [hidden]="isLoading"
    fxFlexFill>
    <ng-container matColumnDef="uuid">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let user">
        {{ user.uuid | slice : 0 : 8 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="registrationTimestamp">
      <th mat-header-cell mat-sort-header="timestamp" *matHeaderCellDef>Registered</th>
      <td mat-cell *matCellDef="let user" style="text-wrap:nowrap; word-break: keep-all;">
        {{ user.registration_timestamp }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastname">
      <th
        mat-header-cell
        mat-sort-header="lastname"
        disableClear
        *matHeaderCellDef
        style="padding-left: 16px;"
      >
        Last name
      </th>
      <td mat-cell *matCellDef="let user" style="padding-left: 16px;">{{ user.lastname }}</td>
    </ng-container>

    <ng-container matColumnDef="firstname">
      <th
        mat-header-cell
        mat-sort-header="firstname"
        disableClear
        *matHeaderCellDef
        style="padding-left: 16px;"
      >
        First Name
      </th>
      <td mat-cell *matCellDef="let user" style="padding-left: 16px;">{{ user.firstname }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th
        mat-header-cell
        mat-sort-header="email"
        disableClear
        *matHeaderCellDef
        style="padding-left: 16px;"
      >
        Email
      </th>
      <td mat-cell *matCellDef="let user" style="padding-left: 16px;">{{ user.email }}</td>
    </ng-container>

    <ng-container matColumnDef="rank">
      <th
        mat-header-cell
        disableClear
        *matHeaderCellDef
        style="padding-left: 16px;"
      >
        Rank
      </th>
      <td mat-cell *matCellDef="let user" style="padding-left: 16px;">{{ user.rank }}</td>
    </ng-container>

    <ng-container matColumnDef="justification" style="max-width: 18px;">
      <th
        mat-header-cell
        mat-sort-header="justification"
        disableClear
        *matHeaderCellDef
        style="padding-left: 16px;"
        >
        Justification
      </th>
      <td mat-cell *matCellDef="let user" style="text-wrap: wrap;padding-left: 16px;">{{ user.justification }}</td>
    </ng-container>

    <ng-container matColumnDef="requestedApplication">
      <th
        mat-header-cell
        mat-sort-header="requested_application"
        style="padding-left: 16px;"
        *matHeaderCellDef>Requested Applications</th>
      <td mat-cell *matCellDef="let user" style="padding-left: 16px;">
        <mat-chip-list fxFlexFill>
          <mat-chip *ngFor="let app of user.requested_application.split(',')" fxFlex="shrink">{{ app }}</mat-chip>
        </mat-chip-list>
      </td>
    </ng-container>

    <ng-container matColumnDef="sponsorEmail">
      <th
        mat-header-cell
        mat-sort-header="sponsor_email"
        disableClear
        *matHeaderCellDef>
        Sponsor E-mail
      </th>
      <td mat-cell *matCellDef="let user">{{ user.sponsor_email }}</td>
    </ng-container>

    <ng-container matColumnDef="sponsorName">
      <th
        mat-header-cell
        mat-sort-header="sponsor_name"
        disableClear
        *matHeaderCellDef>
        Sponsor Name
      </th>
      <td mat-cell *matCellDef="let user">{{ user.sponsor_name }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell disableClear *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let user">
        <div>
          <button mat-icon-button matTooltip="Approve" (click)="approve(user)">
            <mat-icon color="success">check</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Deny" (click)="deny(user)">
            <mat-icon color="warn">close</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
      <mat-progress-spinner *ngIf="isLoading"
          color="accent"
          mode="indeterminate"
          diameter="50"
        >
    </mat-progress-spinner>
</div>
